import React from "react";

import { Container, DetailsContainer, Details, Main } from "./styles/layout";

// TODO type this interface
interface LayoutProps {
  customDetail?: any;
  isMobile?: boolean;
  /** For a page that is already made of cards and wants no card around them. */
  plain?: boolean;
  children?: any;
}

export const Layout: React.FC<LayoutProps> = ({
  customDetail,
  isMobile,
  plain,
  children,
}) => {
  return (
    <Container
      $disableDetails={!customDetail}
      isMobile={isMobile}
      $plain={plain}
    >
      {customDetail && (
        <DetailsContainer>
          <Details>{customDetail()}</Details>
        </DetailsContainer>
      )}

      <Main $detailsDisabled={!customDetail} $plain={plain}>
        {children}
      </Main>
    </Container>
  );
};
